(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spintz-card-title"] && !Shopify.designMode) return;
  try {
    /* Progressive enhancement: equalise only product names in the same visible card row.
   No data requests, cookies, product-data writes, title rewrites or fixed/clipped heights. */
(function () {
  if (window.SPINTZCardTitles) return;
  var selector = '[data-spintz-card-copy]';
  var tracked = new Set();
  var widths = new WeakMap();
  var pending = false;
  var destroyed = false;

  function schedule() {
    if (pending || destroyed) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      align();
    });
  }

  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (entry) {
      var width = entry.contentRect.width;
      var previous = widths.get(entry.target);
      if (previous === undefined || Math.abs(previous - width) > 0.5) {
        widths.set(entry.target, width);
        changed = true;
      }
    });
    if (changed) schedule();
  }) : null;

  function discover() {
    tracked.forEach(function (copy) {
      if (!copy.isConnected) {
        if (resizeObserver) resizeObserver.unobserve(copy);
        tracked.delete(copy);
      }
    });
    document.querySelectorAll(selector).forEach(function (copy) {
      if (!tracked.has(copy)) {
        tracked.add(copy);
        if (resizeObserver) resizeObserver.observe(copy);
      }
    });
  }

  function align() {
    discover();
    var groups = new Map();
    var clear = [];
    tracked.forEach(function (copy) {
      if (!copy.getClientRects().length || copy.clientWidth === 0) return;
      var card = copy.closest('.card-product');
      var name = copy.querySelector('.spintz-card-name-text');
      if (!card || !name) return;
      if (copy.classList.contains('spintz-card-copy--compact') ||
          (card.closest('.list-layout') && window.matchMedia('(min-width: 768px)').matches)) {
        clear.push(copy);
        return;
      }
      var scope = card.closest('.splide__list, #items-grid, #product-grid, [data-spintz-card-grid]') || card.parentElement;
      if (!scope) return;
      var rows = groups.get(scope);
      if (!rows) { rows = []; groups.set(scope, rows); }
      var top = card.getBoundingClientRect().top;
      var row = rows.find(function (candidate) { return Math.abs(candidate.top - top) <= 3; });
      if (!row) { row = { top: top, items: [], height: 0 }; rows.push(row); }
      var lineHeight = parseFloat(window.getComputedStyle(name).lineHeight) || 22;
      var height = Math.max(name.offsetHeight, lineHeight);
      row.height = Math.max(row.height, height);
      row.items.push(copy);
    });
    /* All reads precede writes to avoid repeated forced layout. */
    clear.forEach(function (copy) { copy.style.removeProperty('--spintz-card-name-height'); });
    groups.forEach(function (rows) {
      rows.forEach(function (row) {
        var value = Math.ceil(row.height) + 'px';
        row.items.forEach(function (copy) {
          if (copy.style.getPropertyValue('--spintz-card-name-height') !== value) {
            copy.style.setProperty('--spintz-card-name-height', value);
          }
        });
      });
    });
  }

  function relevant(node) {
    return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
  }

  var mutationObserver;
  function start() {
    if (destroyed) return;
    discover();
    schedule();
    mutationObserver = new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest(selector)) return true;
        return Array.from(record.addedNodes).some(relevant) || Array.from(record.removedNodes).some(relevant);
      });
      if (changed) schedule();
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('load', function (event) {
    if (event.target instanceof HTMLImageElement && event.target.closest('.card-product')) schedule();
  }, true);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
  window.SPINTZCardTitles = { refresh: schedule };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
